export const Dz_WORDS = ['DžOKER', 'DžEZVA', 'DžELAT', 'DžOGER', 'DžOKEJ']
